import cx from "classnames";

import type { CPTCodeSelectOption } from "services/codes-api";

type CPTCodeOptionLabelLayout = "inline" | "stacked";

type CPTCodeOptionLabelMeta = {
  context: "menu" | "value";
};

export const formatCPTCodeOptionLabel = (
  option: CPTCodeSelectOption,
  meta: CPTCodeOptionLabelMeta,
  showInternalBadge = true,
  layout: CPTCodeOptionLabelLayout = "inline",
) => (
  <div
    className={cx("code-option", {
      "code-option--stacked": layout === "stacked",
    })}
  >
    <span>{option.label}</span>
    {showInternalBadge && meta.context === "menu" && option.is_internal && (
      <span className="internal-badge internal-badge--sm">Internal</span>
    )}
  </div>
);
